import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const vaccinationsServices = [
  {
    serviceId: 'VACC_001',
    serviceName: 'Influenza Vaccination',
    category: 'Vaccinations & Immunisations',
    specialty: null,
    subCategory: 'Seasonal Vaccines',
    description: 'Annual flu vaccination for seasonal influenza protection',
    cost: 150,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT, DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'VACC_FLU',
    billableItems: [
      {
        itemId: 'VACC_001',
        itemName: 'Influenza vaccine',
        itemType: 'medication'
      },
      {
        itemId: 'VACC_002',
        itemName: 'Syringe',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.PHARMACY, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['flu', 'vaccination', 'seasonal'],
    displayOrder: 1
  },
  {
    serviceId: 'VACC_002',
    serviceName: 'MMR Vaccination',
    category: 'Vaccinations & Immunisations',
    specialty: null,
    subCategory: 'Childhood Vaccines',
    description: 'Measles, Mumps, and Rubella combination vaccine',
    cost: 280,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'VACC_MMR',
    billableItems: [
      {
        itemId: 'VACC_003',
        itemName: 'MMR vaccine',
        itemType: 'medication'
      },
      {
        itemId: 'VACC_004',
        itemName: 'Syringe',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['mmr', 'childhood', 'vaccination'],
    displayOrder: 2
  },
  {
    serviceId: 'VACC_003',
    serviceName: 'COVID-19 Vaccination',
    category: 'Vaccinations & Immunisations',
    specialty: null,
    subCategory: 'Pandemic Vaccines',
    description: 'COVID-19 vaccination including boosters',
    cost: 200,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT, DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'VACC_COVID',
    billableItems: [
      {
        itemId: 'VACC_005',
        itemName: 'COVID-19 vaccine',
        itemType: 'medication'
      },
      {
        itemId: 'VACC_006',
        itemName: 'Syringe',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.PHARMACY, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['covid', 'pandemic', 'vaccination'],
    displayOrder: 3
  },
  {
    serviceId: 'VACC_004',
    serviceName: 'Travel Vaccinations',
    category: 'Vaccinations & Immunisations',
    specialty: 'Travel Medicine',
    subCategory: 'Travel Health',
    description: 'Comprehensive travel vaccination package including Yellow Fever, Typhoid, Hepatitis A/B',
    cost: 450,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'VACC_TRAVEL',
    billableItems: [
      {
        itemId: 'VACC_007',
        itemName: 'Travel vaccine package',
        itemType: 'medication'
      },
      {
        itemId: 'VACC_008',
        itemName: 'Multiple syringes',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['travel', 'international', 'vaccination'],
    displayOrder: 4
  },
  {
    serviceId: 'VACC_005',
    serviceName: 'HPV Vaccination',
    category: 'Vaccinations & Immunisations',
    specialty: 'Gynecology',
    subCategory: 'Cancer Prevention',
    description: 'Human Papillomavirus vaccination for cervical cancer prevention',
    cost: 1200,
    durationMinutes: 25,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'VACC_HPV',
    billableItems: [
      {
        itemId: 'VACC_009',
        itemName: 'HPV vaccine',
        itemType: 'medication'
      },
      {
        itemId: 'VACC_010',
        itemName: 'Syringe',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['hpv', 'cancer prevention', 'vaccination'],
    displayOrder: 5
  },
  {
    serviceId: 'VACC_006',
    serviceName: 'Tetanus Vaccination',
    category: 'Vaccinations & Immunisations',
    specialty: null,
    subCategory: 'Wound Care',
    description: 'Tetanus vaccination for wound prevention and routine immunization',
    cost: 120,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'VACC_TETANUS',
    billableItems: [
      {
        itemId: 'VACC_011',
        itemName: 'Tetanus vaccine',
        itemType: 'medication'
      },
      {
        itemId: 'VACC_012',
        itemName: 'Syringe',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['tetanus', 'wound', 'vaccination'],
    displayOrder: 6
  }
]

export default vaccinationsServices
